module.exports = __webpack_public_path__ + "static/media/Perception.01aed5c0.jpeg";